module.exports = __webpack_public_path__ + "static/media/banner1.dbde996c.png";